"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = __importDefault(require("./utils"));
const axios_1 = __importDefault(require("axios"));
exports.default = {
    filterPartsByView(document) {
        let newItem = JSON.parse(JSON.stringify(document));
        let viewConfig = JSON.parse(JSON.stringify(document.doc_view_config.sections));
        const getFlat = (data) => data.map(d => [d, ...getFlat(d.sub_sections)]).flat();
        let flatSections = getFlat(viewConfig);
        let allParts = flatSections.map(s => { return s.part_data; }).flat();
        let newList = [];
        allParts
            .filter(p => p.permissions_list.displayPermissionOverride === true || p.permissions_list.displayPermissionOverride === null)
            .forEach((p, idx) => {
            let tmplPartSource = newItem.parttypes.find(x => x.tmpl_part_id === p.tmpl_part_id);
            if (tmplPartSource && !newList.some(n => n.tmpl_part_metadata.tmpl_part_id === p.tmpl_part_metadata.tmpl_part_id)) {
                let removeAttr = tmplPartSource.tmpl_part_metadata.attributes.length === 0;
                p.parts = p.parts.map(part => {
                    let sourcePart = tmplPartSource.parts.find(sp => sp.doc_part_id === part.doc_part_id);
                    return {
                        ...part,
                        attributes: removeAttr ? [] : part.attributes,
                        is_essential: sourcePart.is_essential
                    };
                });
                newList.push({
                    ...p,
                    sequence: idx
                });
            }
            else {
                newList.push({
                    ...p,
                    parts: p.parts.map(part => {
                        return {
                            ...part,
                            childParts: [],
                            childPartTypes: []
                        };
                    }),
                    sequence: idx
                });
            }
        });
        newItem.parttypes = newList.sort((a, b) => (a.sequence > b.sequence && 1) || -1);
        return newItem;
    },
    async docToWordFormat(doc, format, includeNotes) {
        const isPdf = (format && format.toLowerCase() === 'PDF');
        //let tableSections = doc.parttypes.filter(x => x.tmpl_part_metadata.html_export_tag.indexOf("table|")>0);
        let listMarginValue = isPdf ? "10px" : "-10px";
        let listCellMargin = isPdf ? "5px" : "-15px;";
        let pdfTextPadding = isPdf ? "padding-left:5px;" : "";
        const unique = [...new Set(doc.parttypes.map(item => item.tmpl_part_metadata.html_export_tag))];
        let tbl_start = '<table style="width:100%; vertical-align:top; border: 1px solid black;border-collapse: collapse;">';
        let tbl_start_logo = '<table style="width:100%; vertical-align:top; border-collapse: collapse;">';
        let tbl_end = '</table>';
        let docHtmlSections = [];
        let currentTblIdx = "0";
        const ul = "<ul>", ul_e = "</ul>", li = '<li class="lst">', li_e = "</li>", p_s = "<p>", p_e = "</p>", n_s = '<p style="color: gray;"><i>', n_e = "</i></p>";
        let html = unique[0]?.toString().startsWith("table") ? (unique[0]?.toString().startsWith("tableLogo") ? tbl_start_logo : tbl_start) : "";
        unique.forEach((ptg) => {
            let keyValue = ptg?.toString();
            if (keyValue) {
                let isTableElement = keyValue.startsWith("table");
                let tableSections = doc.parttypes.filter(item => item.tmpl_part_metadata.html_export_tag == keyValue);
                if (isTableElement) {
                    let tableData = keyValue.split("|");
                    let headerContent = tableData[1];
                    let tableIdx = tableData[2];
                    let headerColour = tableData[3];
                    const listType = tableData.includes('list');
                    const lightHeader = tableData.includes('light');
                    if (currentTblIdx !== tableIdx) {
                        html += tbl_end + "<br/>";
                        docHtmlSections.push(html);
                        html = "";
                        html += tableData[0] == "tableLogo" ? tbl_start_logo : tbl_start;
                    }
                    currentTblIdx = tableIdx;
                    if (tableData[0] == "tableLogo") {
                        let content = tableSections[0].parts[0].subParts[0].text;
                        if (tableSections[0].parts[0].subParts[0].text) {
                            //let base64 = this.convertImagesToBase64(content);
                            html += `<tr style="border:0"><td>${content}</td></tr>`;
                            //docHtmlSections.push(imgItem);
                        }
                    }
                    else if (tableData[0] == "tableRow") {
                        if (headerContent != "") {
                            var str = '<tr style="border: 1px solid black;' + pdfTextPadding + `border-collapse: collapse; ${lightHeader ? '' : 'color:white;'} background-color:` + headerColour + '"><td style="margin-left:5px;' + pdfTextPadding + '" colspan="2">' + headerContent + '</td></tr>';
                            html += str;
                        }
                        tableSections.forEach(pt => {
                            if (listType) {
                                let textValue = pt.parts[0].text;
                                if (textValue.indexOf("● ") > -1) {
                                    let pieces = textValue.split("● ");
                                    let sublistContent = "<ul style='margin-left: " + listMarginValue + ";'>";
                                    pieces.forEach(part => {
                                        if (part.trim() != "") {
                                            sublistContent += "<li>" + this.handleWhiteSpace(part) + "</li>";
                                        }
                                    });
                                    sublistContent += "</ul>";
                                    let sublisthtmlStr = '<tr style="border: 1px solid black;border-collapse: collapse;"><td colspan="2" style="border: 1px solid black;margin-left:5px;">' + sublistContent + (includeNotes && pt.parts[0].notes ? " " + n_s + this.handleWhiteSpace(pt.parts[0].notes) + n_e : "") + '</td></tr>';
                                    html += sublisthtmlStr;
                                }
                                else {
                                    let listContent = "<ul style='margin-left: " + listMarginValue + ";'><li>" + this.handleWhiteSpace(pt.parts[0].text) + "</li></ul>";
                                    html += '<tr style="border: 1px solid black;border-collapse: collapse;"><td colspan="2" style="border: 1px solid black;margin-left:5px;">' + listContent + '</td></tr>';
                                }
                            }
                            else if (pt.parts[0].subParts && pt.parts[0].subParts.length) {
                                let row = "";
                                let tag, endTag, ulStarted = false;
                                pt.parts[0].subParts.filter(sp => sp.text).forEach((sp, spi) => {
                                    if (sp.type === "listitem") {
                                        tag = li;
                                        endTag = li_e;
                                        if (!ulStarted) {
                                            row += ul;
                                            ulStarted = true;
                                        }
                                    }
                                    else {
                                        tag = p_s;
                                        endTag = p_e;
                                        if (ulStarted) {
                                            row += ul_e;
                                            ulStarted = false;
                                        }
                                    }
                                    let txt = this.handleWhiteSpace(sp.text);
                                    if (spi === 0 && pt.tmpl_part_metadata.display_prefix)
                                        txt = pt.tmpl_part_metadata.display_prefix + " " + txt;
                                    row += `${tag}${txt}${endTag}`;
                                    if (spi === pt.parts[0].subParts.length - 1 && ulStarted) {
                                        row += ul_e;
                                        ulStarted = false;
                                    }
                                });
                                html += '<tr style="border: 1px solid black;border-collapse: collapse;"><td colspan="2" style="border: 1px solid black;margin-left:5px;' + pdfTextPadding + '">' + row + '</td></tr>';
                            }
                            else {
                                let htmlStr = "";
                                htmlStr = '<tr style="border: 1px solid black;border-collapse: collapse;"><td colspan="2" style="border: 1px solid black;margin-left:5px;' + pdfTextPadding + '">' + this.handleWhiteSpace(pt.parts[0].text) + '</td></tr>';
                                html += htmlStr;
                            }
                        });
                    }
                    else {
                        if (headerContent) {
                            var tr = `<tr style="border: 1px solid black;border-collapse: collapse; ${lightHeader ? '' : 'color:white;'} background-color:` + headerColour + '"><td style="margin-left:5px;' + pdfTextPadding + '" colspan="2">' + headerContent + '</td></tr>';
                            html += tr;
                        }
                        tableSections.forEach(pt => {
                            var htmlStr = "";
                            if (pt.tmpl_part_metadata.attributes && pt.tmpl_part_metadata.attributes.length && pt.parts.length == 1) {
                                let attr = pt.tmpl_part_metadata.attributes[pt.tmpl_part_metadata.attributes.length - 1];
                                if (pt.parts[0].text.indexOf(attr.separator) > -1) {
                                    let textSplit = pt.parts[0].text.split(attr.separator);
                                    let content = textSplit[1];
                                    if (content === undefined) {
                                        content = "";
                                    }
                                    htmlStr = '<tr style="border: 1px solid black;border-collapse: collapse;"><td style="border: 1px solid black;width:20%;margin-left:5px;' + pdfTextPadding + '">' + pt.type + '</td><td style="margin-left:5px;border: 1px solid black;vertical-align:top;' + pdfTextPadding + '">' + this.handleWhiteSpace(content) + (includeNotes && pt.parts[0].notes ? " " + n_s + this.handleWhiteSpace(pt.parts[0].notes) + n_e : "") + '</td></tr>';
                                    html += htmlStr;
                                }
                                else {
                                    let content = pt.parts[0].attributes[1].text;
                                    let type = pt.parts[0].attributes[0].text;
                                    htmlStr = '<tr style="border: 1px solid black;border-collapse: collapse;"><td style="border: 1px solid black;width:20%;margin-left:5px;' + pdfTextPadding + '">' + type + '</td><td style="margin-left:5px;border: 1px solid black;vertical-align:top;' + pdfTextPadding + '">' + this.handleWhiteSpace(content) + (includeNotes && pt.parts[0].notes ? " " + n_s + this.handleWhiteSpace(pt.parts[0].notes) + n_e : "") + '</td></tr>';
                                    html += htmlStr;
                                }
                            }
                            else {
                                if (pt.parts && pt.parts.length >= 1) {
                                    var type = pt.type;
                                    if (listType) {
                                        var dataHtml = "<ul style='margin-left: " + listMarginValue + ";'>";
                                        pt.parts.forEach(p => {
                                            if (p.text !== "") {
                                                dataHtml += "<li>" + this.handleWhiteSpace(p.text) + (includeNotes && p.notes ? " " + n_s + this.handleWhiteSpace(p.notes) + n_e : "") + "</li>";
                                            }
                                        });
                                        dataHtml += "</ul>";
                                        htmlStr = '<tr style="border: 1px solid black;border-collapse: collapse;"><td style="border: 1px solid black;width:20%; vertical-align:top;margin-left:5px;' + pdfTextPadding + '">' + type + '</td><td style="margin-left:5px;border: 1px solid black;vertical-align:top;' + pdfTextPadding + '">' + dataHtml + '</td></tr>';
                                        html += htmlStr;
                                    }
                                    else {
                                        var ptIdx = 1;
                                        pt.parts.forEach(p => {
                                            if (p.attributes && p.attributes.length > 1) {
                                                htmlStr = '<tr style="border: 1px solid black;border-collapse: collapse;"><td style="border: 1px solid black;width:20%; vertical-align:top;margin-left:5px;' + pdfTextPadding + '">' + p.attributes[0].text + '</td><td style="border: 1px solid black;vertical-align:top;margin-left:5px;' + pdfTextPadding + '">' + this.handleWhiteSpace(p.attributes[1].text) + (includeNotes && p.notes ? " " + n_s + this.handleWhiteSpace(p.notes) + n_e : "") + '</td></tr>';
                                                html += htmlStr;
                                            }
                                            else {
                                                if ((!pt.tmpl_part_metadata.uses_essential_flag || p.is_essential) && p.text !== "") {
                                                    htmlStr = `<tr style="border: 1px solid black;border-collapse: collapse; ${!headerContent && p.childPartTypes && p.childPartTypes.length && headerColour ? `${lightHeader ? '' : 'color:white;'} background-color:` + headerColour : ''}"><td style="border: 1px solid black;width:20%; vertical-align:top;margin-left:5px;` + pdfTextPadding + '">' + type + " " + ptIdx + '</td><td style="border: 1px solid black;vertical-align:top;margin-left:5px;' + pdfTextPadding + '">' + this.handleWhiteSpace(p.text) + (includeNotes && p.notes ? " " + n_s + this.handleWhiteSpace(p.notes) + n_e : "") + '</td></tr>';
                                                    html += htmlStr;
                                                    if (p.childPartTypes && p.childPartTypes.length > 0) {
                                                        p.childPartTypes.forEach(cpt => {
                                                            if (cpt.parts.length > 0) {
                                                                var subpartHtml = '<tr style="border: 1px solid black;border-collapse: collapse;"><td  align="right"  style="border: 1px solid black;width:20%; vertical-align:top; padding-right: 10px;' + pdfTextPadding + '">' + cpt.type + '</td><td style="border: 1px solid black;vertical-align:top;margin-left:5px;' + pdfTextPadding + '"><ul style="margin-left: ' + listCellMargin + '">'; //+ p.text + '</td></tr>';
                                                                cpt.parts.forEach(sp => {
                                                                    if (sp.text)
                                                                        subpartHtml += "<li>" + this.handleWhiteSpace(sp.text) + (includeNotes && sp.notes ? " " + n_s + this.handleWhiteSpace(sp.notes) + n_e : "") + "</li>";
                                                                });
                                                                subpartHtml += "</ul></td></tr>";
                                                                html += subpartHtml;
                                                            }
                                                        });
                                                    }
                                                    ptIdx++;
                                                }
                                            }
                                        });
                                    }
                                }
                                else {
                                    htmlStr = '<tr style="border: 1px solid black;border-collapse: collapse;"><td style="border: 1px solid black;width:20%; vertical-align:top;margin-left:5px;' + pdfTextPadding + '">' + pt.type + '</td><td style="border: 1px solid black;vertical-align:top;margin-left:5px;' + pdfTextPadding + '">' + this.handleWhiteSpace(pt.parts[0].text) + (includeNotes && pt.parts[0].notes ? " " + n_s + this.handleWhiteSpace(pt.parts[0].notes) + n_e : "") + '</td></tr>';
                                    html += htmlStr;
                                }
                            }
                        });
                    }
                }
                else {
                    if (html !== "") {
                        html += tbl_end + "<br/>";
                        docHtmlSections.push(html);
                        html = "";
                    }
                    tableSections.forEach(pt => {
                        var def_s = "";
                        var def_e = "";
                        switch (pt.tmpl_part_metadata.html_export_tag) {
                            case "bold_centre_large":
                                def_s = '<h2 style="text-align: center; margin: auto;">';
                                def_e = "</h2>";
                                break;
                            case "bold_centre":
                                def_s = '<h3 style="text-align: center; margin: auto;">';
                                def_e = "</h3>";
                                break;
                            case "bold_left_large":
                                def_s = '<h2 style="margin: auto;">';
                                def_e = "</h2>";
                                break;
                            case "bold_left":
                                def_s = '<h4 style="text-align: left;">';
                                def_e = "</h4>";
                                break;
                            case "list":
                            case "bold_list":
                                def_s = "<li>";
                                def_e = "</li>";
                                break;
                        }
                        var tmp = '<table style="width:100%; border-collapse: collapse; text-align:center">' + '<tr><td align="center">' + def_s + this.handleWhiteSpace(pt.parts[0].text) + def_e;
                        if (includeNotes) {
                            if (pt.parts[0].notes) {
                                tmp += n_s + this.handleWhiteSpace(pt.parts[0].notes) + n_e;
                            }
                        }
                        tmp += '</td></tr>' + tbl_end + '<br/>';
                        docHtmlSections.push(tmp);
                    });
                }
            }
        });
        html += tbl_end + "<br/>";
        docHtmlSections.push(html);
        var outputhtml = "";
        docHtmlSections.forEach(s => {
            outputhtml += s;
        });
        //outputhtml = await this.convertImagesToBase64(outputhtml);
        return this.escapeSpecialChars(outputhtml);
    },
    handleWhiteSpace(text) {
        return utils_1.default.sanitize(text)
            .replace(/[\u0080-\u00A0\u2000-\u200B\u2028\u2029\u202F\u205F\u3000\uFEFF\u0002]/gu, " ")
            //remove white space at start/end
            .replace(/(^\s+|\s+$)/g, "")
            //replace line breaks html breaks
            .replace(/(?:\r\n|\r|\n)/g, "<br />")
            //replace double spaces with single
            .replace(/\s{2,}/g, " ");
    },
    escapeSpecialChars(text) {
        let cq = new RegExp(' ', 'g');
        return text.replace(/‘/g, "&lsquo;")
            .replace(/’/g, "&rsquo;")
            .replace(/“/g, "&ldquo;")
            .replace(/”/g, "&rdquo;")
            .replace(/£/g, "&pound;")
            .replace(/€/g, "&euro;")
            .replace(/©/g, "&copy;")
            .replace(/®/g, "&reg;")
            .replace(/–/g, "&ndash;")
            .replace(/—/g, "&mdash;")
            .replace(/™/g, "&trade;")
            .replace(/•/g, "&bull;")
            .replace(cq, " ");
    },
    async docToHTML(doc, section, format, showNotes, USJob, oracle = false) {
        format = format || 'DOCX';
        const forDocxOrPDF = ['DOCX', 'PDF'].includes(format.toUpperCase());
        let html = "";
        let ul = "<ul>", ul_e = "</ul>", li = '<li class="lst">', li_e = "</li>", p_s = "<p>", p_e = "</p>", n_s = '<p style="color: gray;"><i>', n_e = "</i></p>", tb_s = `<table style="width: 100%;" class="bordered"><tbody>`, tb_e = "</tbody></table>", box_s = `<table style="width: 100%;" class="outerborder"><tbody><tr><td>`, box_e = "</td></tr></tbody></table>";
        let overrides = doc.exportOverrides && doc.exportOverrides.length
            ? doc.exportOverrides
            : null;
        let docName = doc.doc_name;
        let inTable = false;
        let inBox = false;
        doc.parttypes.forEach((pt) => {
            let includePT = !section, useDefaultText = false, overrideText = "";
            if (section) {
                // all this just for taleo export
                let applicableSections = (pt.tmpl_part_metadata.html_export_section || "").split("|");
                if (applicableSections.indexOf(section) >= 0) {
                    includePT = true;
                }
                else {
                    let special = applicableSections.find((x) => x.startsWith(section)) || "";
                    useDefaultText = special === section + "_default";
                    let possOverride = null;
                    if (overrides) {
                        possOverride = overrides.find((x) => x.tp_id === pt.tmpl_part_id && doc.classifiers.some(c => c.ct_id === x.ct_id && c.value === x.classifier_value));
                        if (!possOverride)
                            possOverride = overrides.find((x) => x.tp_id === pt.tmpl_part_id && !x.classifier_value);
                    }
                    let override = possOverride &&
                        possOverride.html_export_section.indexOf(section) >= 0
                        ? possOverride
                        : false;
                    if (override && USJob) {
                        overrideText = override.default_text;
                        includePT = true;
                    }
                    else if (special === section + "_usa") {
                        // always export whether location is USA or not
                        includePT = true;
                    }
                }
            }
            if (pt.tmpl_part_metadata.html_export_tag && (pt.tmpl_part_metadata.html_export_tag.indexOf("exclude") >= 0
                || pt.tmpl_part_metadata.html_export_tag.indexOf("excl_" + format.toLowerCase()) >= 0))
                includePT = false;
            if (includePT) {
                let def_s = p_s, def_e = p_e;
                let tags = (pt.tmpl_part_metadata.html_export_tag || "").split(",");
                tags.forEach(tag => {
                    switch (tag) {
                        case "bold_centre_large":
                            def_s = forDocxOrPDF
                                ? '<h2 style="text-align: center; margin: auto;">'
                                : '<h2 align="center">';
                            def_e = "</h2>";
                            break;
                        case "bold_centre":
                            def_s = forDocxOrPDF
                                ? '<h3 style="text-align: center; margin: auto;">'
                                : '<p align="center"><b>';
                            def_e = forDocxOrPDF ? "</h3>" : "</b></p>";
                            break;
                        case "bold_left_large":
                            def_s = forDocxOrPDF
                                ? '<h2 style="margin: auto;">'
                                : '<h2 align="center">';
                            def_e = "</h2>";
                            break;
                        case "bold_left":
                            def_s = forDocxOrPDF ? "<h4>" : "<p><b>";
                            def_e = forDocxOrPDF ? "</h4>" : "</b></p>";
                            if (section === "internal" && !oracle)
                                def_s = "<br>" + def_s;
                            break;
                        case "list":
                        case "bold_list":
                            def_s = li;
                            def_e = li_e;
                            break;
                        case "grid":
                            if (!inTable) {
                                html += tb_s;
                                inTable = true;
                            }
                            break;
                        case "boxborder":
                            if (!inBox) {
                                html += box_s;
                                inBox = true;
                            }
                            break;
                    }
                });
                if (inTable && !tags.includes("grid")) {
                    html += tb_e;
                    inTable = false;
                }
                if (inBox && !tags.includes("boxborder")) {
                    html += box_e;
                    inBox = false;
                }
                let needsULEnd = false;
                let row = "";
                let attributeRow = false;
                let combineAttributes = tags.includes("concat_attrs");
                pt.parts.forEach((p, pi) => {
                    if (pt.tmpl_part_metadata.tmpl_view_section_content_id) {
                        let content = pt.tmpl_part_metadata.content_type === "LABEL" ? p.attributes[0].content_text + "<br />" : p.attributes[0].value;
                        content = pt.tmpl_part_metadata.layout.indexOf("Bold") > -1 ? `<b>${content}</b>` : content;
                        html += this.handleWhiteSpace(content) + "<br />";
                    }
                    else if (!pt.tmpl_part_metadata.uses_essential_flag || p.is_essential) {
                        attributeRow = false;
                        row = "";
                        let tag, endTag, ulStarted = false;
                        if (overrideText) {
                            row += `${def_s}${this.handleWhiteSpace(overrideText)}${def_e}`;
                        }
                        else if (useDefaultText) {
                            row += `${def_s}${this.handleWhiteSpace(pt.tmpl_part_metadata.default_text)}${def_e}`;
                        }
                        else if (combineAttributes && p.attributes && p.attributes.length) {
                            if (def_s === li && pi === 0)
                                row += ul;
                            let txt = this.handleWhiteSpace(utils_1.default.attributesToText(pt.tmpl_part_metadata.attributes, p.attributes));
                            if (pt.tmpl_part_metadata.display_prefix)
                                txt = pt.tmpl_part_metadata.display_prefix + " " + txt;
                            row += `${def_s}${txt}${def_e}`;
                            if (def_s === li && pi === pt.parts.length - 1)
                                row += ul_e;
                        }
                        else if (p.attributes && p.attributes.length) {
                            attributeRow = true;
                            // if (pt.tmpl_part_metadata.html_export_tag.indexOf("list") >= 0) {
                            if (def_s === li && pi === 0) {
                                row += ul;
                                needsULEnd = true;
                            }
                            if (!inTable)
                                row += '<table style="width: 100%"><tbody><tr>';
                            p.attributes.forEach((a) => {
                                if (pt.tmpl_part_metadata.html_export_tag === "hierarchy") {
                                    if (a.text === "" || a.text === "Organisational Structure") {
                                        row += `<td style="width: ${(a.cols * 100) / 12}%; ">${a.text}</td>`;
                                    }
                                    else {
                                        if (a.text === docName) {
                                            row += `<td class="hierarchy1" style="width: ${(a.cols *
                                                100) /
                                                12}%; ">${a.text}</td>`;
                                        }
                                        else {
                                            row += `<td class="hierarchy" style="width: ${(a.cols *
                                                100) /
                                                12}%; ">${a.text}</td>`;
                                        }
                                    }
                                }
                                else {
                                    const txt = this.handleWhiteSpace(a.text) + this.exportChildPartTypes(p);
                                    const boldPt = pt.tmpl_part_metadata.html_export_tag && pt.tmpl_part_metadata.html_export_tag.indexOf("bold") >= 0;
                                    const largePt = pt.tmpl_part_metadata.html_export_tag && pt.tmpl_part_metadata.html_export_tag.indexOf("large") >= 0;
                                    row += `<td class="${boldPt ? "bold-list" : "lst"}" style="width: ${a.cols * 100 / 12}%; ${largePt ? "font-size: 14pt;" : ""}">${txt}</td>`;
                                }
                            });
                            if (!inTable)
                                row += "</tr></tbody></table>";
                            if (def_s === li && pi === pt.parts.length - 1) {
                                (row += ul_e), (needsULEnd = false);
                            }
                            // } else {
                            // }
                        }
                        else if (tags.includes("label")) {
                            attributeRow = true;
                            if (!inTable)
                                row += '<table style="width: 100%"><tbody><tr>';
                            const label = pt.type;
                            row += `<td class="lst" style="width: 50%;">${label}</td>`;
                            const txt = this.handleWhiteSpace(p.text) + this.exportChildPartTypes(p);
                            const boldPt = pt.tmpl_part_metadata.html_export_tag && pt.tmpl_part_metadata.html_export_tag.indexOf("bold") >= 0;
                            const largePt = pt.tmpl_part_metadata.html_export_tag && pt.tmpl_part_metadata.html_export_tag.indexOf("large") >= 0;
                            row += `<td class="${boldPt ? "bold-list" : "lst"}" style="${largePt ? "font-size: 14pt;" : ""}">${txt}</td>`;
                            if (!inTable)
                                row += "</tr></tbody></table>";
                        }
                        else if (p.subParts && p.subParts.length) {
                            if (pt.tmpl_part_metadata.html_export_tag === "list") {
                                if (def_s === li && pi === 0) {
                                    row += ul;
                                    needsULEnd = true;
                                }
                                const txt = this.handleWhiteSpace(p.subParts[0].text) + this.exportChildPartTypes(p);
                                if (txt) {
                                    row += `${def_s}${txt}${def_e}`;
                                    if (def_s === li && pi === pt.parts.length - 1) {
                                        if (showNotes && p.notes) {
                                            row += `${n_s}${p.notes.replace("\n", "<br />")}${n_e}`;
                                        }
                                        (row += ul_e), (needsULEnd = false);
                                    }
                                }
                            }
                            else {
                                p.subParts.filter(sp => sp.text).forEach((sp, spi) => {
                                    if (sp.type === "listitem") {
                                        tag = li;
                                        endTag = li_e;
                                        if (!ulStarted) {
                                            row += ul;
                                            ulStarted = true;
                                        }
                                    }
                                    else {
                                        tag = def_s;
                                        endTag = def_e;
                                        if (ulStarted) {
                                            row += ul_e;
                                            ulStarted = false;
                                        }
                                    }
                                    let txt = this.handleWhiteSpace(sp.text) + this.exportChildPartTypes(p);
                                    if (spi === 0 && pt.tmpl_part_metadata.display_prefix)
                                        txt = pt.tmpl_part_metadata.display_prefix + " " + txt;
                                    row += `${tag}${txt}${endTag}`;
                                    if (spi === p.subParts.length - 1 && ulStarted) {
                                        row += ul_e;
                                        ulStarted = false;
                                    }
                                });
                            }
                        }
                        else {
                            if (def_s === li && pi === 0)
                                row += ul;
                            let txt = this.handleWhiteSpace(p.text) + this.exportChildPartTypes(p);
                            if (pt.tmpl_part_metadata.display_prefix)
                                txt = pt.tmpl_part_metadata.display_prefix + " " + txt;
                            row += `${def_s}${txt}${def_e}`;
                            if (def_s === li && pi === pt.parts.length - 1)
                                row += ul_e;
                        }
                        // add the export default text if it is not empty and the field is
                        if (pt.tmpl_part_metadata.export_default_text &&
                            p.subParts[0].text === "") {
                            let def_blue = def_s.replace(new RegExp("/>/g"), ' style="color: blue;">');
                            row += `${def_blue}${pt.tmpl_part_metadata.export_default_text}${def_e}`;
                        }
                        if (showNotes && p.notes && pi !== pt.parts.length - 1) {
                            row += `${n_s}${p.notes.replace("\n", "<br />")}${n_e}`;
                        }
                        if (inTable) {
                            if (attributeRow)
                                html += `<tr>${row}</tr>`;
                            else
                                html += `<tr><td>${row}</td></tr>`;
                        }
                        else {
                            html += row;
                        }
                    }
                });
                if (inTable && tags.includes("end")) {
                    html += tb_e + "<br />";
                    inTable = false;
                }
                if (inBox && tags.includes("end")) {
                    html += box_e + "<br />";
                    inBox = false;
                }
                if (needsULEnd)
                    html += ul_e;
            }
        });
        if (inTable)
            html += tb_e;
        if (inBox)
            html += box_e;
        if (forDocxOrPDF) {
            //html = await this.convertImagesToBase64(html);
            // make sure we trim br's from start and end of element content on all doc conversions
            return this.escapeSpecialChars(html);
        }
        else {
            //trying to change this as removing br after other tags is removing double br tags used for export spacing
            return html;
            // make sure we trim br's from start and end of element content on all doc conversions
            //return html.replace(/>\s?<br\s?\/?>/gi, '>').replace(/<br\s?\/?>\s?<\//gi, '</');
        }
    },
    exportChildPartTypes(part, rowData = null) {
        let output = "";
        let listStyle = rowData?.opts?.list_style === 'Ordered' ? 'ol' : 'ul';
        if (part.childParts?.length) {
            output += `<${listStyle}>`;
            output += part.childParts
                .filter((c) => c.text)
                .reduce((p, c) => {
                return p + `<li>${this.handleWhiteSpace(c.text)}</li>`;
            }, "");
            output += `</${listStyle}>`;
            return output;
        }
        if (!part.childPartTypes)
            return "";
        part.childPartTypes.forEach(cpt => {
            let cps = cpt.parts.filter(cp => cp.text);
            let childData = rowData?.childRows?.find(r => r.tmpl_part_id === cpt.tmpl_part_id);
            let listStyle = childData?.opts?.list_style === 'Ordered' ? 'ol' : 'ul';
            let displayEssentialFlag = childData?.opts?.display_essential_flag;
            if (cps.length) {
                output += `<${listStyle}>`;
                cps.forEach(cp => {
                    let essentialFlag = "";
                    if (displayEssentialFlag)
                        essentialFlag = ` ${cp.is_essential ? "(Essential)" : "(Non-Essential)"}`;
                    output += `<li>${this.handleWhiteSpace(cp.text)}${essentialFlag}${this.exportChildPartTypes(cp, childData)}</li>`;
                });
                output += `</${listStyle}>`;
            }
        });
        return output;
    },
    async convertImagesToBase64(html) {
        const re = /<img[^>]+src="(http[^">]+)"/ig;
        const results = html.match(re);
        if (results) {
            let items = results.map(x => x.replace(/.*src="(http[^"]*)".*/, '$1'));
            for (const r of items) {
                const response = await (0, axios_1.default)(r, { responseType: 'arraybuffer' });
                const buffer64 = Buffer.from(response.data, 'binary').toString('base64');
                let b64Content = "data:image/png;base64," + buffer64;
                html = html.replace(r, b64Content);
            }
        }
        return html;
    },
    containsTableExportTag(doc) {
        const unique = [...new Set(doc.parttypes.map(item => item.tmpl_part_metadata.html_export_tag))];
        let exportFormatTable = false;
        unique.forEach(export_tag => {
            if (export_tag !== null && export_tag !== undefined) {
                if (export_tag.toString().startsWith("table")) {
                    exportFormatTable = true;
                }
            }
        });
        return exportFormatTable;
    },
    async generateExport(doc, format, full) {
        doc = doc.doc_view_config ? this.filterPartsByView(doc) : doc;
        let exportFormatTable = this.containsTableExportTag(doc);
        let html = `<!DOCTYPE  html><html><body>
          <style>
            p, h2, h3, h4 { font-family: calibri; }
            .lst { font-family: calibri; font-size: 12pt; }
            .bold-list { font-family: calibri; font-size: 12pt; font-weight: bold; }
            .hierarchy { font-family: calibri;font-size: 12pt;font-weight:bold;border:1px black solid;text-align:center;background-color:lightblue;border-radius:4px}
            .hierarchy1 { font-family: calibri; font-size: 12pt; font-weight: bold; border: 1px black solid; text-align:center; background-color: yellow }
            table.bordered { width: 100%; border-collapse: collapse; }
            table.bordered td { border: 1px solid black; padding: 5px; }
            table.outerborder { width: 100%; border-collapse: collapse; border: 1px solid black; }
            table.outerborder td { padding: 5px; }
            table.outerborder table td { padding: 0; }
            div.chip-red { color: red; }
            div.chip-orange { color: orange; }
            div.chip-green { color: green; }
			.pageBreak { page-break-before:always }
          </style>${exportFormatTable ? await this.docToWordFormat(doc, format, full) : await this.docToHTML(doc, null, format, full)}</body></html>`;
        return html;
    },
    convertHtmlToRtf(html, fullDoc) {
        if (!(typeof html === "string" && html)) {
            return null;
        }
        //var tmpRichText, 
        var hasHyperlinks;
        var richText = html;
        richText = richText.replace(/[\u{0080}-\u{00A0}]/gu, " ");
        if (fullDoc) {
            // Catch p or h with nested b tags Making Job Title larger if full doc selected ...
            richText = richText.replace(/^<(?:p align="center"><b>)/gi, "\n{\\pard\\qc{\\f0\\b\\fs34{}");
        }
        //replace br tags with new lines
        richText = richText.replace(/<br\s?\/?>/gi, "{\n\\line}");
        //table tags; get each table in content, process each tr tag and each td inside each tr, inside each table
        //double tab the TD content and then newline each TR
        //last table gets an extra buffer line to space out 
        let tableReg = new RegExp("<table.*?>(.*?)</table>", "gi");
        let trReg = new RegExp("<tr.*?>(.*?)</tr>", "gi");
        let tdReg = new RegExp("<td.*?>(.*?)</td>", "gi");
        let tables = html.match(tableReg);
        if (tables) {
            tables.forEach((t, idx) => {
                let newRowItems = t.match(trReg)?.map((x) => {
                    return x.replace(trReg, "$1");
                }).map(r => {
                    return r.match(tdReg)?.map((x) => { return x.replace(tdReg, "$1"); }).join('\t\t');
                });
                let newRows = (newRowItems ? newRowItems.join("{\n\\line}") : "") + "{\n\\line}";
                richText = richText.replace(t, idx === (tables.length - 1) ? newRows + "{\n\\line}" : newRows);
            });
        }
        // Singleton tags
        richText = richText.replace(/<(?:hr)(?:\s+[^>]*)?\s*[\\/]?>/gi, "\n{\\pard \\brdrb \\brdrs \\brdrw10 \\brsp20 \\par}\n\r{\\pard\\par}");
        richText = richText.replace(/<(?:br)(?:\s+[^>]*)?\s*[\\/]?>/gi, "\n{\\pard\\par\\sect}");
        // Empty tags
        richText = richText.replace(/<(?:p|h[1-6]|div|section|article)(?:\s+[^>]*)?\s*[\\/]>/gi, "{\\pard\\sect}");
        richText = richText.replace(/<(?:[^>]+)\/>/g, "");
        // Hyperlinks
        richText = richText.replace(/<a(?:\s+[^>]*)?(?:\s+href=(["'])(?:javascript:void\(0?\);?|#|return false;?|void\(0?\);?|)\1)(?:\s+[^>]*)?>/gi, "{{{\n");
        let allLinks = new RegExp(/<a.*?>.*?<\/a>/, "gi");
        let results = richText.match(allLinks);
        if (results) {
            hasHyperlinks = true;
            results.forEach(r => {
                let reg2 = new RegExp(/<a[\s\S]*?href="([^"]+)"[\s\S]*?>(.*)<\/a>/, "gi");
                let urlMatch = reg2.exec(r);
                if (urlMatch) {
                    richText = richText.replace(urlMatch[0], '{\\field{\\*\\fldinst HYPERLINK\n ' + urlMatch[1] + '"}{\\fldrslt{\\ul\\cf1' + urlMatch[2] + '}}}');
                }
            });
        }
        // Start tags
        richText = richText.replace(/<(?:p align="center"><b>)/gi, "\n{\\pard\\qc{\\f0\\b\\fs25{}");
        richText = richText.replace(/<(?:b|strong)(?:\s+[^>]*)?>/gi, "{\\f0\\b\\fs27{}");
        richText = richText.replace(/<(?:i|em)(?:\s+[^>]*)?>/gi, "{\\i\n");
        richText = richText.replace(/<(?:u|ins)(?:\s+[^>]*)?>/gi, "{\\ul\n");
        richText = richText.replace(/<(?:strike|del)(?:\s+[^>]*)?>/gi, "{\\strike\n");
        richText = richText.replace(/<sup(?:\s+[^>]*)?>/gi, "{\\super\n");
        richText = richText.replace(/<sub(?:\s+[^>]*)?>/gi, "{\\sub\n");
        richText = richText.replace(/<(?:p|h[1-6]|div|section|article)(?:\s+[^>]*)?>/gi, "\n{\\f0\\pard{}");
        richText = richText.replace(/<(?:li)(?:\s+[^>]*)?\s*[\\/]?>/gi, "\n{\\f0 {\\pntext \\bullet\\tab}{\\pn\\pnlvlblt\\pnstart1{\\pntxtb\\bullet}}{\\ltrch{}");
        // End tags
        richText = richText.replace(/<\/(?:p|h[1-6]|div|section|article)(?:\s+[^>]*)?>/gi, "\n\\line\\par}");
        richText = richText.replace(/<\/(?:ul)(?:\s+[^>]*)?>/gi, "\\line{}");
        richText = richText.replace(/<\/(?:b|strong|i|em|u|ins|strike|del|sup|sub)(?:\s+[^>]*)?>/gi, "}");
        richText = richText.replace(/<(?:\/li)(?:\s+[^>]*)?\s*[\\/]?>/gi, "}\\li720\\ri0\\sa0\\sb0\\jclisttab\\tx720\\fi-360\\ql\\par}");
        // Strip any other remaining HTML tags [but leave their contents]
        richText = richText.replace(/<(?:[^>]+)>/g, "");
        richText = richText
            .replace(/‘/g, "\\'91")
            .replace(/’/g, "\\'92")
            .replace(/“/g, "\\'93")
            .replace(/”/g, "\\'94")
            .replace(/£/g, "\\'a3")
            .replace(/€/g, "\\'80")
            .replace(/©/g, "\\'a9")
            .replace(/®/g, "\\'ae")
            .replace(/–/g, "\\'96")
            .replace(/—/g, "\\'97")
            .replace(/™/g, "\\'99")
            .replace(/&amp;/g, "\\'26")
            .replace(/•/g, "\\'95");
        // Prefix and suffix the rich text with the necessary syntax
        richText =
            "{\\rtf1\\ansi\\deff0{\\fonttbl{\\f0 Open-Sans;}}" +
                (hasHyperlinks ? "{\\colortbl\n;\n\\red0\\green0\\blue255;\n}\n" : "") +
                richText +
                "\n}";
        return richText;
    },
    stripTags(htmlValue) {
        let textValue = htmlValue.replace(/<\/div>/ig, '\n')
            .replace(/<\/li>/ig, '\n')
            .replace(/<li class="lst">/ig, '  •  ')
            .replace(/<\/td>/ig, ' ')
            .replace(/<\/ul>/ig, '\n')
            .replace(/<\/p>/ig, '\n\n')
            .replace(/<\/h\d>/ig, '\n\n')
            .replace(/<br\s*[\\/]?>/gi, "\n");
        return utils_1.default.removeTags(textValue);
    },
    getMimeType(docType) {
        switch (docType.toUpperCase()) {
            case "DOCX":
                return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            case "RTF":
                return "text/rtf";
            case "HTML":
                return "text/html";
            case "PDF":
                return "application/pdf";
            default:
                return "application/octet-stream";
        }
    },
};
